import { IAppState, ITrackingData } from '../common/state';
import { prepareTrackingData } from '../utils/prepareTrackingData';

export function getTrackingData(state: IAppState): ITrackingData {
  const { filters, results, user, breadcrumbs } = state;

  return prepareTrackingData(filters, results, breadcrumbs, user);
}
